import { render, staticRenderFns } from "./CapituloSeis18Page.vue?vue&type=template&id=2a346904"
import script from "./CapituloSeis18Page.js?vue&type=script&lang=js&external"
export * from "./CapituloSeis18Page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports